import React, {useEffect} from 'react';
import * as TreeFunctions from '../utilities/TreeFunctions';
import TabVariables from '../Tabs/TabVariables';

function App(props) {

  var currentList = props.currentList;
  var error = props.error;
  var organicChanges = props.organicChanges;
  var addToExtraScreen = props.addToExtraScreen;
  var userNos = props.userNos;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;

  // const [pathDown, setPathDown] = useState([]);
  useEffect(()=>{

    if (!currentList.mu){
      var changes = [{t:'w', w:['mu'], n:{}}];
      organicChanges(changes);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!currentList.mu){
    return <div>Loading...</div>
  }
//

  return <TabVariables addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} currentList={currentList} error={error} userNos={userNos} questions={TreeFunctions.musicQuestions()} source='mu' leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} />

}
//


export default App;
